export default "__VITE_ASSET__ccd82572__"